<template>
  <generic-container
    :title="$t('mixin')"
    icon="js"
    :show_plus="false"
    :searchable="false"
    style="margin-top: 15px"
  >
    <div class="ui three item top attached tabular menu" ref="tabs">
      <a class="active item" data-tab="code">
        <i class="js icon"></i> {{ $t("code") }}</a
      >
      <a class="item" data-tab="validation">
        <i class="check icon"></i> {{ $t("validation") }}</a
      >
      <a class="item" data-tab="style">
        <i class="css3 icon"></i> {{ $t("style") }}</a
      >
    </div>
    <div class="ui bottom attached active tab segment" data-tab="code">
      <code-editor
        v-model="code"
        type="javascript"
        theme="monokai"
        ref="code_editor"
        :title="$t('code')"
        :show_format="true"
        :header_menus="mixin_header_menus"
        ><div class="ui info message" style="display: block">
          <div class="header">{{ $t("hints") }}</div>
          <ul class="list">
            <li
              v-html="
                $t(
                  'define an object which contains a data attribute, methods and everything you need to set the functionality',
                )
              "
            ></li>
            <li
              v-html="$t('please refer to vue mixin site for more information')"
            ></li>
          </ul></div
      ></code-editor>
    </div>
    <div class="ui bottom attached tab segment" data-tab="validation">
      <code-editor
        v-model="validation"
        type="javascript"
        theme="monokai"
        ref="validation_editor"
        :title="$t('validation rules')"
        :show_format="true"
        :header_menus="validation_header_menus"
        ><div class="ui info message" style="display: block">
          <div class="header">{{ $t("hints") }}</div>
          <ul class="list">
            <li
              v-html="
                $t(
                  'define an object which contains every validated field and the rules to validate',
                )
              "
            ></li>
            <li
              v-html="
                $t(
                  'please refer to fomanti form validation site for more information',
                )
              "
            ></li>
          </ul></div
      ></code-editor>
    </div>
    <div class="ui bottom attached tab segment" data-tab="style">
      <code-editor
        v-model="style"
        type="css"
        icon="css3"
        theme="monokai"
        ref="style_editor"
        :title="$t('css code')"
        :show_format="true"
      ></code-editor>
    </div>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import CodeEditor from "@/components/code_editor/Index";
import filters from "@/filters";

export default {
  name: "MixinManagement",
  filters: filters,
  props: { human_task: Object, templates: Array },
  components: {
    GenericContainer,
    CodeEditor,
  },
  data() {
    return {
      code: "",
      validation: "",
      style: "",
    };
  },
  computed: {
    mixin_header_menus() {
      let vm = this;
      return [
        {
          tooltip: this.$t("format code"),
          icon: "wrench",
          buttons: this.templates
            .filter((t) => t.type == "mixin")
            .map((n) => {
              return {
                icon: n.icon,
                text: n.name,
                click: function () {
                  vm.$refs.code_editor.insert_content(n.template);
                },
              };
            }),
        },
      ];
    },
    validation_header_menus() {
      let vm = this;
      return [
        {
          tooltip: this.$t("format code"),
          icon: "wrench",
          buttons: this.templates
            .filter((t) => t.type == "validation")
            .map((n) => {
              return {
                icon: n.icon,
                text: n.name,
                click: function () {
                  vm.$refs.validation_editor.insert_content(n.template);
                },
              };
            }),
        },
      ];
    },
  },
  methods: {},
  mounted() {
    setTimeout(() => {
      if (this.human_task && this.human_task.mixin)
        this.code = this.human_task.mixin;
      if (this.human_task && this.human_task.validation)
        this.validation = this.human_task.validation;
    }, 2000);
    window.jQuery(this.$refs.tabs).find(".item").tab();
  },
  watch: {
    code() {
      this.human_task.mixin = this.code;
    },
    validation() {
      this.human_task.validation = this.validation;
    },
    style() {
      this.human_task.style = this.style;
    },
  },
};
</script>

<style scoped></style>
